<script setup lang="ts">
import { toRefs } from "vue";

type SizeTypes = "sm" | "md" | "lg" | "xl";

interface Props {
  gap?: SizeTypes;
}

const props = withDefaults(defineProps<Props>(), {
  gap: "md",
});

const { gap } = toRefs(props);
const STYLE_MAP: Record<SizeTypes, string> = {
  sm: "gap-1",
  md: "gap-2",
  lg: "gap-3",
  xl: "gap-4",
};
</script>

<template>
  <div :class="['flex flex-col', STYLE_MAP[gap]].join(' ')">
    <slot></slot>
  </div>
</template>
